import React from "react";
import { Box, Button, Modal, Typography } from "@mui/material";
import EditNodeForm from "./EditNodeForm";

const getTitle = (module) => {
  let name = "Name";
  if (module == "Deals") {
    name = "Deal_Name";
  } else if (module == "Accounts") {
    name = "Account_Name";
  } else if (module == "Contacts" || module == "Leads") {
    name = "Full_Name";
  } else if (module == "Campaigns") {
    name = "Campaign_Name";
  }
  return "${" + name + "}";
};

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 1100,
  maxWidth: "85%",
  bgcolor: "background.paper",
  borderRadius: "5px",
  // border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

function CreateModalNode({
  currentNodeInfo,
  createModalOpen,
  handleCreateModalClose,
  addNodeUnderParent,
  changeNodeAtPath,
  getNodeKey,
  moduleFields,
  leadFields,
  savedData,
  myTreeData,
  moduleName,
}) {
  return (
    <Modal
      open={createModalOpen}
      onClose={handleCreateModalClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      {/* 
      
            saveFolder: currentNodeInfo?.node?.information?.saveFolder || null,
            copyLeadFolder: currentNodeInfo?.node?.information?.copyLeadFolder || null,
            usePreviousFolder: currentNodeInfo?.node?.information?.usePreviousFolder || null,
            moveFolderIfExist: currentNodeInfo?.node?.information?.moveFolderIfExist || null,

            shareUrl: currentNodeInfo?.node?.information?.shareUrl || null,
            shareUrlPassword: currentNodeInfo?.node?.information?.shareUrlPassword || null,
            shareUrlPasswordField: currentNodeInfo?.node?.information?.shareUrlPasswordField || null,
            shareUrlDuration: currentNodeInfo?.node?.information?.shareUrlDuration || null,

            fullAccessShareUrl: currentNodeInfo?.node?.information?.fullAccessShareUrl || null,
            fullAccessShareUrlPassword: currentNodeInfo?.node?.information?.fullAccessShareUrlPassword || null,
            fullAccessShareUrlPasswordField: currentNodeInfo?.node?.information?.fullAccessShareUrlPasswordField || null,
            fullAccessShareUrlDuration: currentNodeInfo?.node?.information?.fullAccessShareUrlDuration || null,

            collectionLinkField: currentNodeInfo?.node?.information?.collectionLinkField || null,
            collectionLinkName: currentNodeInfo?.node?.information?.collectionLinkName || null,
            collectionLinkDuration: currentNodeInfo?.node?.information?.collectionLinkDuration || null,

             */}

      <Box sx={style}>
        <EditNodeForm
          moduleName={moduleName}
          title={getTitle(moduleName)}
          information={{
            saveFolder: { value: null, isChecked: false },
            copyLeadFolder: { value: null, isChecked: false },
            usePreviousFolder: { value: null, isChecked: false },
            moveFolderIfExist: { value: null, isChecked: false },

            shareUrl: { value: null, isChecked: false, password: null },
            fullAccessShareUrl: {
              value: null,
              isChecked: false,
              password: null,
            },
            collectionLink: {
              value: null,
              isChecked: false,
              name: null,
              duration: null,
            },
          }}
          moduleFields={moduleFields}
          leadFields={leadFields}
          myTreeData={currentNodeInfo ? myTreeData : []}
          handleSubmitForm={(data) => {
            const myData = addNodeUnderParent({
              treeData: currentNodeInfo ? myTreeData : [],
              parentKey: currentNodeInfo
                ? currentNodeInfo?.path[currentNodeInfo?.path?.length - 1]
                : null,
              expandParent: true,
              getNodeKey,
              newNode: {
                information: data.information,
                title: data?.title,
              },
            });

            savedData({
              key: "treeData",
              response: myData?.treeData,
            });

            handleCreateModalClose();
          }}
          handleTempSubmitForm={(data) => {
            // const myData = changeNodeAtPath({
            //   treeData: myTreeData,
            //   path: currentNodeInfo.path,
            //   getNodeKey,
            //   newNode: {
            //     ...currentNodeInfo.node,
            //     information: data.information,
            //     title: data?.title,
            //   },
            // });

            // savedData({
            //   key: "treeData",
            //   response: myData,
            // });
          }}
          handleCreateModalClose={handleCreateModalClose}
        />
      </Box>
    </Modal>
  );
}

export default CreateModalNode;
